import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';

import { IconButton, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import * as S from './styles';

export default function Dropzone(props) {
  const [myFiles, setMyFiles] = useState([]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      setMyFiles([...myFiles, ...acceptedFiles]);
    },
    [myFiles]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    maxFiles: 1,
    accept:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    // accept: 'application/vnd.ms-excel',
    onDrop,
    disabled: false, // props.disabled
    maxSize: 6291456,
  });

  useEffect(() => {
    props.onCallback(myFiles);
  }, [myFiles]);

  useEffect(() => {
    if (props.cleanList) {
      setMyFiles([]);
    }
  }, [props.cleanList]);

  const files = myFiles.map((file, index) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes{' '}
      <IconButton onClick={() => removeFile(index)} color="secondary">
        <Close />
      </IconButton>
    </li>
  ));

  const removeFile = (fileIndex) => {
    const newFiles = myFiles.filter((item, index) => index != fileIndex);
    setMyFiles(newFiles);
  };

  return (
    <div className="container" style={{ marginBottom: '20px' }}>
      <S.Container
        {...getRootProps({ className: 'dropzone' })}
        style={{ position: 'relative', zIndex: 0 }}
      >
        <input {...getInputProps()} />

        {/* <p>{'Arquivos acima de 6 Megabytes são rejeitados!'}</p> */}

        <p>Pode ser selecionado até 1 arquivos simultâneos!</p>

        <p>
          Após selecionar o arquivo, clicar no Confirma para upload do mesmo!
        </p>

        <br />
        <p>
          {props.loading
            ? 'Carregando...'
            : 'Arrastar arquivo ou clicar no Selecionar arquivo'}
        </p>
        <br />

        {files.length <= 0 && (
          <Button
            type="button"
            onClick={open}
            color="primary"
            size="small"
            variant="contained"
            style={{ display: props.loading ? 'none' : 'block' }}
          >
            Selecionar arquivo
          </Button>
        )}
      </S.Container>

      <div>
        {files.length > 0 && (
          <aside>
            <h4 style={{ marginTop: '1em' }}>Arquivo(s) para upload</h4>
            <ul>{files}</ul>
          </aside>
        )}
      </div>
    </div>
  );
}
